import AWS from 'aws-sdk';
import accountRequest from 'services/account';
import { v4 as uuid } from 'uuid';

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const AWS_REGION = process.env.REACT_APP_AWS_REGION;
const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;

const uploadFile = async (file, onProgress, onSuccess, onError, accountId) => {
    const key = uuid();
    const bucket = S3_BUCKET;
    const res = await accountRequest.getAccountTokens(accountId);
    AWS.config.region = AWS_REGION;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: AWS_IDENTITY_POOL_ID,
        IdentityId: res.IdentityId,
        Logins: {
            'cognito-identity.amazonaws.com': res.Token,
        },
    });

    const s3 = new AWS.S3();
    s3.upload(
        {
            Bucket: bucket,
            Key: `${key}/${file.name}`,
            Body: file,
            ContentType: file.type,
            ACL: 'public-read',
        },
        (err) => {
            if (err) {
                onError(err);
            }
            if (onSuccess) {
                onSuccess({ bucket, key, type: file.type, name: file.name });
            }
        }
    ).on('httpUploadProgress', (p) => {
        onProgress({ percent: (p.loaded / p.total) * 100 });
    });
};

export { uploadFile };
